import { Injectable } from '@angular/core';
import { S3ProductPublicService } from './s3-product-public.service';

@Injectable({ providedIn: 'root' })
export class S3SrmPublicService extends S3ProductPublicService {
  protected buildProbeImageUrl(month: string): string {
    return `${this.bucketBaseUrl}/${this.monthPrefix}${month}/srm/srm_brasil_${month}.png`;
  }
}
